// import {
//   Component,
//   ElementRef,
//   Input,
//   OnInit,
//   Output,
//   ViewChild,
//   EventEmitter,
//   OnChanges,
//   SimpleChanges,
// } from '@angular/core';
// import { NotificationService } from 'src/app/utils/notification.service';
// import { UtilityService } from 'src/app/utils/utility.service';
// import { environment } from 'src/environments/environment';

// @Component({
//   selector: 'app-file-upload-ui',
//   templateUrl: './file-upload-ui.component.html',
//   styleUrls: ['./file-upload-ui.component.css'],
// })
// export class FileUploadUiComponent implements OnInit, OnChanges {
//   @ViewChild('fileInput', { static: false }) fileInput: ElementRef;
//   @ViewChild('imageElem', { static: false }) imageElem: ElementRef;

//   @Input() acceptPdf: boolean = false;
//   @Input() classNames: string;
//   @Input() highlightBorder: boolean;
//   @Input() disabled: boolean;
//   @Input() editing: boolean;
//   @Input() label: string;
//   @Input() currentPhoto: string;
//   public defaultPhoto =
//     '../../../../../../assets/images/aquila-placeholder.svg';
//   public initialLable: string;

//   @Output() upload: EventEmitter<any> = new EventEmitter();
//   @Output() removeFile: EventEmitter<null> = new EventEmitter();

//   file: any;
//   isFileUploaded: boolean = false;

//   constructor(
//     private toast: NotificationService,
//     private utils: UtilityService
//   ) {}

//   ngOnChanges(changes: SimpleChanges): void {
//     this.isFileUploaded = changes['currentPhoto']?.currentValue ? true : false;
//   }
//   getLocalizedImageText() {
//     return $localize`:@@imageLabel:Image`;
//   }
//   ngOnInit(): void {
//     this.initialLable = this.label;
//   }

//   defaultImagePlaceholder(ev: any) {
//     return (ev.target.src = this.defaultPhoto);
//   }

//   selectFile() {
//     if (this.disabled) return;
//     this.fileInput.nativeElement.click();
//   }

//   setSelectedImg(ev: any) {
//     const file = ev.target.files[0];

//     const fileSizeValid = this.utils.limitFileSize(file.size);

//     if (!fileSizeValid) {
//       this.toast.error('File uploaded should not be more that 2MB');
//       return;
//     }

//     const reader = new FileReader();
//     reader.onload = (e: any) => {
//       const img = new Image();
//       img.src = e.target.result;

//       const fileType = file.type;
//       const isPdf = fileType === 'application/pdf';
//       if (isPdf && this.acceptPdf) {
//         this.label = file.name;
//         this.isFileUploaded = true;
//         this.upload.emit(reader.result);
//         return;
//       }

//       img.onload = (rs) => {
//         this.label = file.name;
//         this.imageElem.nativeElement.src = reader.result;
//         this.isFileUploaded = true;

//         this.upload.emit(reader.result);
//       };

//       img.onerror = (err: any) => {
//         if (err.type == 'error') {
//           this.toast.error(
//             `Kindly upload an image ${this.acceptPdf ? 'or pdf' : ''}`
//           );
//         }
//       };
//     };

//     reader.readAsDataURL(file);
//   }

//   dataURLToBlob(dataURL) {
//     const arr = dataURL.split(',');
//     const mime = arr[0].match(/:(.*?);/)[1];
//     const bstr = atob(arr[1]);
//     let n = bstr.length;
//     const u8arr = new Uint8Array(n);

//     while (n--) u8arr[n] = bstr.charCodeAt(n);

//     return new Blob([u8arr], { type: mime });
//   }

//   public get formatLabel() {
//     if (!this.label) return '';
//     if (this.label.length > 25) {
//       return this.label.slice(0, 15) + '...' + this.label.slice(-10);
//     }
//     return this.label;
//   }

//   onRemoveFile() {
//     this.label = this.initialLable;
//     this.imageElem.nativeElement.src = '';
//     this.fileInput.nativeElement.value = '';
//     this.isFileUploaded = false;
//     this.removeFile.emit(null);
//   }

//   viewFile() {}
// }

// file-upload-ui.component.ts
// import {
//   Component,
//   ElementRef,
//   Input,
//   OnInit,
//   Output,
//   ViewChild,
//   EventEmitter,
//   OnChanges,
//   SimpleChanges,
// } from '@angular/core';
// import { NotificationService } from 'src/app/utils/notification.service';
// import { UtilityService } from 'src/app/utils/utility.service';
// import { environment } from 'src/environments/environment';

// @Component({
//   selector: 'app-file-upload-ui',
//   templateUrl: './file-upload-ui.component.html',
//   styleUrls: ['./file-upload-ui.component.css'],
// })
// export class FileUploadUiComponent implements OnInit, OnChanges {
//   @ViewChild('fileInput', { static: false }) fileInput: ElementRef;
//   @ViewChild('imageElem', { static: false }) imageElem: ElementRef;

//   @Input() acceptPdf: boolean = false;
//   @Input() classNames: string;
//   @Input() highlightBorder: boolean;
//   @Input() disabled: boolean;
//   @Input() editing: boolean;
//   @Input() label: string;
//   @Input() currentPhoto: string;
//   public defaultPhoto =
//     '../../../../../../assets/images/aquila-placeholder.svg';
//   public initialLable: string;

//   @Output() upload: EventEmitter<any> = new EventEmitter();
//   @Output() removeFile: EventEmitter<null> = new EventEmitter();

//   file: any;
//   isFileUploaded: boolean = false;
//   showImageModal: boolean = false;
//   currentFileUrl: string = '';
//   currentFileName: string = '';
//   isPdfFile: boolean = false;

//   constructor(
//     private toast: NotificationService,
//     private utils: UtilityService
//   ) {}

//   ngOnChanges(changes: SimpleChanges): void {
//     this.isFileUploaded = changes['currentPhoto']?.currentValue ? true : false;
//     if (this.isFileUploaded) {
//       this.currentFileUrl = changes['currentPhoto']?.currentValue;
//     }
//   }

//   getLocalizedImageText() {
//     return $localize`:@@imageLabel:Image`;
//   }

//   ngOnInit(): void {
//     this.initialLable = this.label;
//   }

//   defaultImagePlaceholder(ev: any) {
//     return (ev.target.src = this.defaultPhoto);
//   }

//   selectFile() {
//     if (this.disabled) return;
//     this.fileInput.nativeElement.click();
//   }

//   setSelectedImg(ev: any) {
//     const file = ev.target.files[0];

//     const fileSizeValid = this.utils.limitFileSize(file.size);

//     if (!fileSizeValid) {
//       this.toast.error('File uploaded should not be more that 2MB');
//       return;
//     }

//     const reader = new FileReader();
//     reader.onload = (e: any) => {
//       const img = new Image();
//       img.src = e.target.result;

//       const fileType = file.type;
//       const isPdf = fileType === 'application/pdf';

//       if (isPdf && this.acceptPdf) {
//         this.label = file.name;
//         this.currentFileName = file.name;
//         this.currentFileUrl = reader.result as string;
//         this.isPdfFile = true;
//         this.isFileUploaded = true;
//         this.upload.emit(reader.result);
//         return;
//       }

//       img.onload = (rs) => {
//         this.label = file.name;
//         this.currentFileName = file.name;
//         this.currentFileUrl = reader.result as string;
//         this.isPdfFile = false;
//         this.imageElem.nativeElement.src = reader.result;
//         this.isFileUploaded = true;

//         this.upload.emit(reader.result);
//       };

//       img.onerror = (err: any) => {
//         if (err.type == 'error') {
//           this.toast.error(
//             `Kindly upload an image ${this.acceptPdf ? 'or pdf' : ''}`
//           );
//         }
//       };
//     };

//     reader.readAsDataURL(file);
//   }

//   dataURLToBlob(dataURL) {
//     const arr = dataURL.split(',');
//     const mime = arr[0].match(/:(.*?);/)[1];
//     const bstr = atob(arr[1]);
//     let n = bstr.length;
//     const u8arr = new Uint8Array(n);

//     while (n--) u8arr[n] = bstr.charCodeAt(n);

//     return new Blob([u8arr], { type: mime });
//   }

//   public get formatLabel() {
//     if (!this.label) return '';
//     if (this.label.length > 25) {
//       return this.label.slice(0, 15) + '...' + this.label.slice(-10);
//     }
//     return this.label;
//   }

//   onRemoveFile() {
//     this.label = this.initialLable;
//     this.imageElem.nativeElement.src = '';
//     this.fileInput.nativeElement.value = '';
//     this.isFileUploaded = false;
//     this.currentFileUrl = '';
//     this.currentFileName = '';
//     this.isPdfFile = false;
//     this.removeFile.emit(null);
//   }

//   viewFile() {
//     if (this.isPdfFile) {
//       // For PDF files, open in new tab
//       window.open(this.currentFileUrl, '_blank');
//     } else {
//       // For images, show in modal
//       this.showImageModal = true;
//     }
//   }

//   closeImageModal() {
//     this.showImageModal = false;
//   }

//   // Handle click outside modal to close
//   onModalBackdropClick(event: any) {
//     if (event.target === event.currentTarget) {
//       this.closeImageModal();
//     }
//   }
// }

// file-upload-ui.component.ts
import {
  Component,
  ElementRef,
  Input,
  OnInit,
  Output,
  ViewChild,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { NotificationService } from 'src/app/utils/notification.service';
import { UtilityService } from 'src/app/utils/utility.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-file-upload-ui',
  templateUrl: './file-upload-ui.component.html',
  styleUrls: ['./file-upload-ui.component.css'],
})
export class FileUploadUiComponent implements OnInit, OnChanges {
  @Input() compact = false;
  /** Keep the compact eagle card visible; clicking still previews an uploaded file. */
  @Input() alwaysShowCompactPlaceholder = false;
  @Input() previewOnClick = false;
  onUploadClick(): void {
    if (this.previewOnClick && this.isFileUploaded) this.viewFile();
    else this.selectFile();
  }

  @ViewChild('fileInput', { static: false }) fileInput: ElementRef;
  @ViewChild('imageElem', { static: false }) imageElem: ElementRef;
  @Input() showMagnifyExclusively: boolean = false;
  @Input() disabledUpload: boolean = false;

  @Input() acceptPdf: boolean = false;
  // Default to '' so the template's `[ngClass]="[..., classNames]"` array never
  // ends up containing `undefined` when a caller (e.g. the guarantor tab uploaders
  // on new-loan-account) omits this input. Otherwise Angular NgClass throws
  // "can only toggle CSS classes expressed as strings, got undefined" mid-tick,
  // and every button whose click depends on that change-detection pass (the
  // basic-tab Next button, prominently) stops working.
  @Input() classNames: string = '';
  @Input() highlightBorder: boolean;
  @Input() disabled: boolean;
  @Input() editing: boolean;
  @Input() label: string;
  /* Overrides the default accepted-formats/size line under the label, for
     callers whose design specifies different formats or a different cap. */
  @Input() hint: string;
  @Input() currentPhoto: string;
  @Input() fullWidthWhenUploaded: boolean = false;

  // @Output() viewPhotoExclusively;
  @Input() ccEdit: boolean = false;
  @Input() shouldShowViewIcon: boolean = false;
  public defaultPhoto =
    '../../../../../../assets/images/aquila-placeholder.svg';
  public initialLable: string;
  public pdfBlobUrl;

  @Input() showViewIconExclusiveLy: boolean = false;
  @Output() upload: EventEmitter<any> = new EventEmitter();
  /* The raw File, for callers that submit multipart rather than base64. Emitted
     alongside `upload` (which carries the base64 data URL), so existing callers
     are unaffected — they simply do not bind it. */
  @Output() fileSelected: EventEmitter<File> = new EventEmitter();
  @Output() removeFile: EventEmitter<null> = new EventEmitter();
  /* Optional per-caller size cap (bytes), stricter than the default 2MB. A larger file is refused before it is read
     or previewed, and reported through `rejected` so the caller can explain it. */
  @Input() maxBytes: number;
  @Output() rejected: EventEmitter<File> = new EventEmitter();
  @Input() showMagnifyOnly: boolean = false;

  file: any;
  isFileUploaded: boolean = false;
  showImageModal: boolean = false;
  currentFileUrl: string = '';
  currentFileName: string = '';
  isPdfFile: boolean = false;

  constructor(
    private toast: NotificationService,
    private utils: UtilityService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    const newPhoto = changes['currentPhoto']?.currentValue;
    this.isFileUploaded = !!newPhoto;

    if (newPhoto) {
      this.currentFileUrl = newPhoto;
      // `isFileUploaded` creates the image in this same change-detection pass.
      // Apply the source after it mounts as well, otherwise an earlier failed
      // protected URL can leave the native element stuck on the placeholder.
      setTimeout(() => {
        if (this.currentPhoto === newPhoto && this.imageElem?.nativeElement) {
          this.imageElem.nativeElement.src = newPhoto;
        }
      });
    } else {
      this.currentFileUrl = '';
    }
  }
  public get safeCurrentPhoto(): SafeUrl | string {
    if (!this.currentPhoto) return '';
    if (
      typeof this.currentPhoto === 'string' &&
      this.currentPhoto.startsWith('data:')
    ) {
      return this.sanitizer.bypassSecurityTrustUrl(this.currentPhoto);
    }
    return this.currentPhoto; // regular https URL — untouched
  }

  getLocalizedImageText() {
    return $localize`:@@imageLabel:Image`;
  }

  ngOnInit(): void {
    this.initialLable = this.label;
  }

  defaultImagePlaceholder(ev: any) {
    return (ev.target.src = this.defaultPhoto);
  }

  selectFile() {
    if (this.disabled || this.disabledUpload) return;
    this.fileInput.nativeElement.click();
  }

  setSelectedImg(ev: any) {
    const file = ev.target.files[0];
    if (!file) return;

    if (this.maxBytes && file.size > this.maxBytes) {
      ev.target.value = '';
      this.rejected.emit(file);
      return;
    }

    const fileSizeValid = this.utils.limitFileSize(file.size);

    if (!fileSizeValid) {
      this.toast.error('File uploaded should not be more that 2MB');
      return;
    }

    // Hand the File to callers that submit multipart; the base64 data URL still
    // follows via `upload`, so callers binding only that are unaffected.
    this.fileSelected.emit(file);

    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      const fileType = file.type;
      const isPdf = fileType === 'application/pdf';

      if (isPdf && this.acceptPdf) {
        this.label = file.name;
        this.currentFileName = file.name;
        this.currentFileUrl = result;
        this.isPdfFile = true;
        this.isFileUploaded = true;
        this.upload.emit(result);
        return;
      }

      // Validate the file is a decodable image. Attach the handlers BEFORE
      // assigning `src` — for base64 data URLs the browser can finish decoding
      // synchronously, so a handler attached after `src` may miss the `load`
      // event entirely, leaving the form control unset ("photo required")
      // even though a placeholder image is showing.
      const img = new Image();

      img.onload = () => {
        this.label = file.name;
        this.currentFileName = file.name;
        this.currentFileUrl = result;
        this.isPdfFile = false;
        if (this.imageElem?.nativeElement) {
          this.imageElem.nativeElement.src = result;
        }
        this.isFileUploaded = true;

        this.upload.emit(result);
      };

      img.onerror = () => {
        this.toast.error(
          `Kindly upload an image ${this.acceptPdf ? 'or pdf' : ''}`,
        );
      };

      img.src = result;
    };

    reader.readAsDataURL(file);
  }

  dataURLToBlob(dataURL) {
    const arr = dataURL.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) u8arr[n] = bstr.charCodeAt(n);

    return new Blob([u8arr], { type: mime });
  }

  public get formatLabel() {
    if (!this.label) return '';
    if (this.label.length > 25) {
      return this.label.slice(0, 15) + '...' + this.label.slice(-10);
    }
    return this.label;
  }

  onRemoveFile() {
    this.label = this.initialLable;
    this.imageElem.nativeElement.src = '';
    this.fileInput.nativeElement.value = '';
    this.isFileUploaded = false;
    this.currentFileUrl = '';
    this.currentFileName = '';
    this.isPdfFile = false;
    this.removeFile.emit(null);
  }
  public openImage(path: string) {
    const imgPath = environment.baseUrl + environment.coreUrl + 'data/';

    window.open(`${imgPath}${path}`, '_blank');
  }
  getFullImageUrl(path: any): string {
    if (typeof path !== 'string' || !path) return '';
    if (path.includes('base64') || path.startsWith('http')) {
      return path;
    }
    const imgPath = environment.baseUrl + environment.coreUrl + 'data/';
    return `${imgPath}${path}`;
  }

  public get isBase64Photo(): boolean {
    return (
      typeof this.currentFileUrl === 'string' &&
      this.currentFileUrl.includes('base64')
    );
  }

  viewFile() {
    if (this.isPdfFile) {
      this.downloadFile();
    } else {
      // For images, show in modal
      this.showImageModal = true;
    }
  }

  // Method to download the file
  downloadFile() {
    if (this.currentFileUrl && this.currentFileName) {
      const link = document.createElement('a');
      link.href = this.currentFileUrl;
      link.download = this.currentFileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  // Open file in new tab (alternative to modal)
  openInNewTab() {
    if (this.currentFileUrl) {
      window.open(this.currentFileUrl, '_blank');
    }
  }

  closeImageModal() {
    this.showImageModal = false;
  }

  // Handle click outside modal to close
  onModalBackdropClick(event: any) {
    if (event.target === event.currentTarget) {
      this.closeImageModal();
    }
  }
}
